<template>
	<div class="shop-workbench-nav">
		<div class="nav-content">
			<div
				v-for="item in navList"
				:key="item.key"
				class="nav-item"
				:class="{ active: activeKey === item.key, disabled: item.disabled }"
				@click="handleClick(item)"
			>
				<div class="icon-wrapper">
					<i :class="item.icon"></i>
				</div>
				<span class="nav-text">{{ item.label }}</span>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'ShopWorkbenchNav',
		props: {
			activeKey: {
				type: String,
				default: 'my'
			}
		},
		data() {
			return {
				navList: [
					{ key: 'my', label: '我的店铺', icon: 'el-icon-s-shop', path: '/mall/shop/my' },
					{ key: 'publish', label: '发布商品', icon: 'el-icon-s-order', path: '/mall/shop/goods-publish' },
					{ key: 'manage', label: '商品管理', icon: 'el-icon-s-goods', path: '/mall/shop/goods-manage' },
					{ key: 'order', label: '订单管理', icon: 'el-icon-document', disabled: true }
				]
			}
		},
		methods: {
			handleClick(item) {
				if (item.disabled || !item.path || this.$route.path === item.path) return
				this.$router.push(item.path)
			}
		}
	}
</script>

<style lang="scss" scoped>
	.shop-workbench-nav {
		position: relative;
		z-index: 2;
		width: 100%;
		height: 74px;
		margin: 0 0 20px;
		background: rgba(255, 255, 255, 0.7);
		backdrop-filter: blur(10px);
		box-shadow: 0px 7px 13px 0px rgba(52, 132, 223, 0.19);
		box-sizing: border-box;
	}

	.nav-content {
		display: flex;
		align-items: center;
		justify-content: space-around;
		width: $main-page-width;
		height: 74px;
		margin: 0 auto;
	}

	.nav-item {
		position: relative;
		display: flex;
		align-items: center;
		padding: 10px 20px;
		border-radius: 8px;
		text-decoration: none;
		cursor: pointer;
		transition: all 0.3s;

		&::after {
			content: '';
			position: absolute;
			left: 50%;
			bottom: -10px;
			width: 0;
			height: 3px;
			background: #79a8df;
			transform: translateX(-50%);
			transition: all 0.3s ease;
		}

		&.active {
			&::after {
				width: 100%;
			}

			.nav-text {
				color: #267ecb;
			}
		}

		&:not(.disabled):hover {
			transform: translateY(-2px);

			&::after {
				width: 80%;
			}

			.icon-wrapper {
				background: #267ecb;
			}

			.nav-text {
				color: #267ecb;
			}
		}

		&.disabled {
			cursor: not-allowed;
			opacity: 0.75;
		}
	}

	.icon-wrapper {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 36px;
		height: 36px;
		margin-right: 20px;
		border-radius: 50%;
		color: #ffffff;
		background-image: linear-gradient(0deg, #98cefe 0%, #67acfe 100%);
		transition: all 0.3s;

		i {
			font-size: 18px;
			color: #ffffff;
			transition: all 0.3s;
		}
	}

	.nav-text {
		font-size: 18px;
		font-weight: 500;
		color: #333333;
		transition: all 0.3s;
	}
</style>
